import DelectoryResource from '../DelectoryResource';

const OneHour = 1000 * 60 * 60;

class Exports extends DelectoryResource {
  constructor(opts) {
    super(opts);

    this.wineSearcher = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/exports/wine_searcher',
      cacheConfig: {
        browserOnly: false,
        genKey: (payload) => {
          return JSON.stringify(payload.payload);
        },
        ttl: OneHour
      }
    });

    this.banquetInventory = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/exports/banquet_inventory',
      // cacheConfig: {
      //   browserOnly: false,
      //   genKey: (payload) => {
      //     return JSON.stringify(payload.payload);
      //   },
      //   ttl: OneHour
      // }
    });

    this.banquetInventoryAll = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/exports/banquet_inventory_all',
      cacheConfig: {
        browserOnly: false,
        genKey: (payload) => {
          return JSON.stringify(payload.payload);
        },
        ttl: OneHour
      }
    });

    this.banquetOrders = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/exports/banquet_orders',
      cacheConfig: {
        browserOnly: false,
        genKey: (payload) => {
          return JSON.stringify(payload.payload);
        },
        ttl: OneHour
      }
    });

    this.banquetOrdersBrief = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/exports/banquet_orders_brief',
      cacheConfig: {
        browserOnly: false,
        genKey: (payload) => {
          return JSON.stringify(payload.payload);
        },
        ttl: OneHour
      }
    });

    this.googleProducts = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/exports/google_products',
      // cacheConfig: {
      //   browserOnly: false,
      //   genKey: (payload) => {
      //     return JSON.stringify(payload.payload);
      //   },
      //   ttl: OneHour
      // }
    });
  }
}

export default Exports;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/resources/Exports.js